import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import NotPromise  from './views/401.vue'
// import Ulist from './views/user/Ulist.vue'

import Home from './views/Home.vue'
import Main from './views/Main.vue'
import Table from './views/nav1/Table.vue'
import Form from './views/nav1/Form.vue'
import Rules from './views/nav1/Rules.vue'


let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
     {
        path: '/401',
        component: NotPromise,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        redirect:'/table',
        component: Home,
        name: '用户管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            // { path: '/', component: Table, name: '主页', hidden: true },
            { path: '/table', component: Table, name: '用户信息' },
            { path: '/form', component: Form, name: '权限管理' },
            { path: '/rule', component: Rules, name: '规则管理' },
            // { path: '/user', component: user, name: '列表' },
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js